import { Outlet } from 'react-router-dom';
import layoutImg from '../../assets/auth/layout.webp';

export const AuthLayout = () => {
  return (
    <div className="flex px-4 py-6 2xl:px-6 2xl:py-9">
      <div className="basis-7/12">
        <p className="text-3xl font-bold 2xl:text-5xl">
          <span className="text-secondary">Cross</span>
          <span className="text-primary">Buildz.</span>
        </p>
        <Outlet />
      </div>

      <div className="basis-5/12">
        <img src={layoutImg} alt="Engineers" />
      </div>
    </div>
  );
};
